module.exports = __webpack_public_path__ + "static/img/wisdomsuccess2.54a29b08.png";